import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TopNav from "../../../components/TopNav";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";
import { replaceString } from "../../../utils/helpers/dataHelper";
import { HiArrowCircleRight } from "react-icons/hi";
import { getUserDocumentTrackingStatus } from "../../../actions/document.action";

const DocumentStatusTab = ({ desc, status }) => (
  <div className="bg-gray-100 p-2 flex justify-between my-3 ">
    <div>
      <HiArrowCircleRight
        size="30"
        className="react-icon-style compass_color"
      />
    </div>
    <div> {desc}</div>
    <div> {status === null ? "Pending" : status}</div>
  </div>
);

export default function DocumentTracking() {
  const history = useHistory();
  const location = useLocation();
  const payload = location.state;
  const dispatch = useDispatch();

  useEffect(() => {
    if (payload === undefined) {
      history.goBack();
    } else {
      dispatch(getUserDocumentTrackingStatus(payload.id));
    }
  }, []);

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    document: {
      userDocumentProcessingLoading,
      trackingStatusList,
      trackingLoading,
    },
  } = useSelector(({ documentReducer }) => ({ document: documentReducer }));

  const loadState =
    profile.userProfileLoading === Loading.FETCHING ||
    trackingLoading === Loading.FETCHING ||
    userDocumentProcessingLoading === Loading.FETCHING;

  return (
    <>
      <div className="overflow-hidden">
        <div className=" doc_processing_color h-44 px-2 pt-3">
          <TopNav link={"/document-processing"} />
          <div className="transcript_header capitalize">
            {replaceString(payload.documentType)} Tracking
          </div>
          <div className="text-md md:text-lg md:w-2/3">
            Track your Certificate, Transcript, English Waiver etc.
          </div>
        </div>
      </div>

      {loadState ? (
        <RoundLoader />
      ) : (
        <div>
          <>
            <div className="bg-white px-2 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="font-bold md:text-lg md:w-2/3">
                Please note that each request takes 5 working days after payment
                and confirmation of all documentation provided.
              </div>

              <div className="mt-10">
                <div className="flex justify-between mb-3">
                  <div></div>
                  <div className="font-bold">Description</div>
                  <div className="font-bold">Status</div>
                </div>
                {trackingStatusList.map((ts) => {
                  return (
                    <DocumentStatusTab
                      desc={ts.description}
                      status={ts.cycleStatus}
                    />
                  );
                })}
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
}
